<template>
  <router-view></router-view>
</template>
<script>
import { onMounted, onUnmounted } from "vue";
import { handleForceLogout } from "@/utils/auth";

// 解决ERROR ResizeObserver loop completed with undelivered notifications.
//问题的
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};
// 解决ERROR ResizeObserver loop completed with undelivered notifications.
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
};

// 全局事件监听器
let forceLogoutHandler = null;

export default {
  name: "App",
  setup() {
    onMounted(() => {
      // 监听强制登出事件
      forceLogoutHandler = (event) => {
        const message =
          event.detail?.message || "您的账号在其他终端登录，已被强制下线";
        handleForceLogout(message);
      };
      window.addEventListener("user-force-logout", forceLogoutHandler);
    });

    onUnmounted(() => {
      // 清理事件监听器
      if (forceLogoutHandler) {
        window.removeEventListener("user-force-logout", forceLogoutHandler);
      }
    });
  },
};
</script>
<style lang="scss">
html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

.el-container,
.el-main {
  height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* 全局按钮图标间距调整 */
.el-button .el-icon + span,
.el-button .el-icon ~ span {
  margin-left: 4px !important;
}

.el-button span .el-icon {
  margin-right: 4px !important;
}

/* Element Plus 按钮内部图标间距 */
.el-button > .el-icon {
  margin-right: 4px !important;
}

.el-button > .el-icon:last-child {
  margin-right: 0 !important;
}
</style>
